<script setup>
console.log(window.DIALTONE_CONSTANTS);

const kindModifiers = Object.keys(window.DIALTONE_CONSTANTS.BUTTON_KIND_MODIFIERS).filter(k => k !== 'inverted');
const importanceModifiers = Object.keys(window.DIALTONE_CONSTANTS.BUTTON_IMPORTANCE_MODIFIERS);

const importanceDescriptions = {
  clear: 'Default level of importance. Typically used for secondary or minimally important actions.',
  outlined: 'Slightly more important than clear, presenting a contrasting border and transparent background.',
  primary: 'Highest level of importance, presenting a solid background color.',
};
const kindDescriptions = {
  default: 'Our default button colors.',
  danger: 'Potentially destructive or otherwise critical actions.',
  positive: 'Used to communicate positive actions.',
  inverted: 'Use for placement on non-white, dark backgrounds.',
  muted: 'For non-primary actions and contexts where base style may not work.',
  unstyled: 'Raw button devoid of any style.',
};
</script>

<template>
  <table class="d-table dialtone-doc-table d-mbe-200">
    <colgroup>
      <col>
      <col class="d-w25p">
      <col class="d-w25p">
      <col class="d-w25p">
    </colgroup>
    <thead>
      <tr>
        <th class="d-ta-left d-va-top" aria-hidden="true" />
        <th v-for="importance in importanceModifiers" :key="importance" class="d-ta-left d-va-top">
          <div class="d-mbe-50">
            {{ importance }}
          </div>
          <dt-text kind="body" :size="200" density="200" class="d-tt-none">
            {{ importanceDescriptions[importance] }}
          </dt-text>
        </th>
      </tr>
    </thead>
    <tbody>
      <tr v-for="kind in kindModifiers" :key="kind">
        <th class="d-ta-left d-pis-0" scope="row">
          <a class="d-link d-fs-100 d-fw-medium d-d-block d-mbe-50 d-tt-uppercase" :href="`#${kind}`">
            <strong>{{ kind }}</strong>
          </a>
          <dt-text kind="body" :size="200" density="200">
            {{ kindDescriptions[kind] }}
          </dt-text>
        </th>
        <td
          v-for="importance in importanceModifiers"
          :key="importance"
          :class="[
            'd-ta-center',
            { 'd-bgc-contrast': kind === 'inverted' },
          ]"
        >
          <span v-if="kind === 'unstyled'">N/A</span>
          <dt-button v-else-if="importance !== 'primary' || kind !== 'muted'" :importance="importance" :kind="kind">
            Place call
          </dt-button>
          <span v-else>N/A</span>
        </td>
      </tr>
    </tbody>
  </table>
</template>
